import React, { useContext } from "react";
import BetSlipContext from "../../context/BetSlipContext";

const BacLayNew = ({
  name,
  odds_back,
  odds_lay,
  limit,
  oldLay,
  oldBack,
  item,
  index,
  disabelBack,
  handelChange,
  disabelLay,component
}) => {
  const { betSlipObject, showBetDialog } = useContext(BetSlipContext);
  let checkDisabled = (odds) => {
    if (Number(odds) > 0) {
      if (Number(odds) > limit?.oddsLimit) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };
  function isRtValid(obj) {

    // Allow undefined, null, "", or 0
    if (obj?.rt === undefined || obj?.rt === null || obj?.rt === "" || obj?.rt === 0)
      return "single-disabled";

    // If limit is specified and rt is a number, check if it's within limit
    if (typeof obj?.rt === "number" && limit !== undefined) {
      return obj?.rt >= limit?.oddsLimit ? "single-disabled" : "";
    }

    // Otherwise, not valid
    return "";
  }

  let check = (odds) => {
    if (Number(odds?.rt) > limit?.oddsLimit) {
      return "single-disabled";
    } else {
      return "";
    }
  };

  const handelChangeBack = (item, odds, id, classBg, index) => {
    return `bid position-relative curser-pointer ${classBg} ${
      isRtValid(odds[id]) == "single-disabled" ? "disabled-new-div" : ""
    } ${
      betSlipObject?.teamName == (item?.RunnerName || item?.runnerName) &&
      betSlipObject?.odds == odds[id]?.rt &&
      betSlipObject?.betType == "back" &&
      showBetDialog
        ? "back-active"
        : ""
    }  ${
      Number(
        document
          .getElementById(
            `${component}back_odds_` + (item.SelectionId || item?.selectionID) + index
          )
          ?.title?.split("-")[0]
          ?.trim()
      ) !== odds[id]?.rt && "spark-back"
    }
          ${
            Number(
              document
                .getElementById(
                  `${component}back_odds_` + (item.SelectionId || item?.selectionID) + index
                )
                ?.title?.split("-")[1]
                ?.trim()
            ) !== odds[id]?.bv && "spark-back"
          } `;
  };

  const handelChangeLay = (item, odds, id, classBg, index) => {
    return `ask position-relative curser-pointer ${classBg} ${
      disabelLay || isRtValid(odds[id]) == "single-disabled"
        ? "disabled-new-div"
        : ""
    } ${
      betSlipObject?.teamName == (item?.RunnerName || item?.runnerName) &&
      betSlipObject?.odds == odds[id]?.rt &&
      betSlipObject?.betType == "lay" &&
      showBetDialog
        ? "lay-active"
        : ""
    } ${
      Number(
        document
          .getElementById(
           `${component}lay_odds_` + (item.SelectionId || item?.selectionID) + index
          )
          ?.title?.split("-")[0]
          ?.trim()
      ) !== odds[id]?.rt && "spark-lay"
    }
            ${
              Number(
                document
                  .getElementById(
                    `${component}lay_odds_` +
                      (item.SelectionId || item?.selectionID) +
                      index
                  )
                  ?.title?.split("-")[1]
                  ?.trim()
              ) !== odds[id]?.bv && "spark-lay"
            }
          }`;
  };
  return (
    <>
      <div class="widt50fleft">
        <div
          style={{ cursor: "pointer" }}
          title={`${oldBack?.length > 0 && oldBack[2]?.rt}-${
            oldBack?.length > 0 && oldBack[2]?.bv
          }`}
          id={`${component}back_odds_` + (item.SelectionId || item?.selectionID) + index}
          onClick={() => {
            if (!disabelBack) {
              if (!checkDisabled(odds_back[2]?.rt)) {
                handelChange(
                  odds_back[2],
                  "back",
                  item?.RunnerName || item?.runnerName,
                  item,
                  index
                );
              }
            }
          }}
          class={handelChangeBack(item, odds_back, 2, "back-light-bg1", index)}
        >
          {isRtValid(odds_back[2]) == "single-disabled" && (
            <span className="disabled"></span>
          )}
          <span class="bid-price">{odds_back[2]?.rt || ""}</span>
          {name != "Bookmaker" && (
            <span class="bid-price-small">{odds_back[2]?.bv || ""}</span>
          )}
        </div>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (!disabelBack) {
              if (!checkDisabled(odds_back[1]?.rt)) {
                handelChange(
                  odds_back[1],
                  "back",
                  item?.RunnerName || item?.runnerName,
                  item,
                  index
                );
              }
            }
          }}
          id={`${component}back_odds_` + (item.SelectionId || item?.selectionID) + index}
          title={`${oldBack?.length > 0 && oldBack[1]?.rt}-${
            oldBack?.length > 0 && oldBack[1]?.bv
          }`}
          class={handelChangeBack(item, odds_back, 1, "back-light-bg", index)}
        >
          {isRtValid(odds_back[1]) == "single-disabled" && (
            <span className="disabled"></span>
          )}
          <span class="bid-price">{odds_back[1]?.rt || ""}</span>
          {name != "Bookmaker" && (
            <span class="bid-price-small">{odds_back[1]?.bv || ""}</span>
          )}
        </div>

        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (!disabelBack) {
              if (!checkDisabled(odds_back[0]?.rt)) {
                handelChange(
                  odds_back[0],
                  "back",
                  item?.RunnerName || item?.runnerName,
                  item,
                  index
                );
              }
            }
          }}
          title={`${oldBack?.length > 0 && oldBack[0]?.rt}-${
            oldBack?.length > 0 && oldBack[0]?.bv
          }`}
          id={`${component}back_odds_` + (item.SelectionId || item?.selectionID) + index}
          class={handelChangeBack(item, odds_back, 0, "", index)}
        >
          {isRtValid(odds_back[0]) == "single-disabled" && (
            <span className="disabled"></span>
          )}
          <span class="bid-price">{odds_back[0]?.rt || ""}</span>
          {name != "Bookmaker" && (
            <span class="bid-price-small">{odds_back[0]?.bv || ""}</span>
          )}
        </div>
      </div>
      <div class="widt50fleft">
        <div
          style={{ cursor: "pointer" }}
          id={`${component}lay_odds_` + (item.SelectionId || item?.selectionID) + index}
          title={`${oldLay?.length > 0 && oldLay[0]?.rt}-${
            oldLay?.length > 0 && oldLay[0]?.bv
          }`}
          onClick={() => {
            if (!disabelLay) {
              if (!checkDisabled(odds_lay[0]?.rt)) {
                handelChange(
                  odds_lay[0],
                  "lay",
                  item?.RunnerName || item?.runnerName,
                  item,
                  index
                );
              }
            }
          }}
          class={handelChangeLay(item, odds_lay, 0, "marg1", index)}
        >
          {isRtValid(odds_lay[0]) == "single-disabled" && (
            <span className="disabled"></span>
          )}
          <span class="bid-price">{odds_lay[0]?.rt || ""}</span>
          {name != "Bookmaker" && (
            <span class="bid-price-small">{odds_lay[0]?.bv || ""}</span>
          )}
        </div>
        <div
          style={{ cursor: "pointer" }}
          id={`${component}lay_odds_` + (item.SelectionId || item?.selectionID) + index}
          title={`${oldLay?.length > 0 && oldLay[1]?.rt}-${
            oldLay?.length > 0 && oldLay[1]?.bv
          }`}
          onClick={() => {
            if (!disabelLay) {
              if (!checkDisabled(odds_lay[1]?.rt)) {
                handelChange(
                  odds_lay[1],
                  "lay",
                  item?.RunnerName || item?.runnerName,
                  item,
                  index
                );
              }
            }
          }}
          class={handelChangeLay(item, odds_lay, 1, "lay-light-bg", index)}
        >
          {" "}
          {isRtValid(odds_lay[1]) == "single-disabled" && (
            <span className="disabled"></span>
          )}
          <span class="bid-price">{odds_lay[1]?.rt || ""}</span>
          {name != "Bookmaker" && (
            <span class="bid-price-small">{odds_lay[1]?.bv || ""}</span>
          )}
        </div>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (!disabelLay) {
              if (!checkDisabled(odds_lay[2]?.rt)) {
                handelChange(
                  odds_lay[2],
                  "lay",
                  item?.RunnerName || item?.runnerName,
                  item,
                  index
                );
              }
            }
          }}
          id={`${component}lay_odds_` + (item.SelectionId || item?.selectionID) + index}
          title={`${oldLay?.length > 0 && oldLay[2]?.rt}-${
            oldLay?.length > 0 && oldLay[2]?.bv
          }`}
          class={handelChangeLay(item, odds_lay, 2, "lay-light-bg1", index)}
        >
          {" "}
          {isRtValid(odds_lay[2]) == "single-disabled" && (
            <span className="disabled"></span>
          )}
          <span class="bid-price">{odds_lay[2]?.rt || ""}</span>
          {name != "Bookmaker" && (
            <span class="bid-price-small">{odds_lay[2]?.bv || ""}</span>
          )}
        </div>
      </div>
    </>
  );
};

export default BacLayNew;
